{
  "completed": "Ολοκληρώθηκε:  ",
  "current": "Τρέχον:  ",
  "notCompleted": "Μη ολοκληρωμένο:  ",
  "steplist": "Λίστα βημάτων"
}
